import styled from 'styled-components';
import { spacing } from 'ui/theme';
import set from 'lodash/set';
import { MediumContent } from 'modules/graphql/types';
import { MovableInkIconButton } from './MovableInkIconButton';
import { CreativeLibraryIconButton } from './CreativeLibraryIconButton';
import { MediumDataKey } from '../types';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useHasMovableInkTile } from 'modules/templateEditor/common/hooks';

export const IconSuffixWrapper = styled.div`
  display: flex;
  gap: ${spacing.threeQuarter};
`;

export const DATA_TEST_ID = 'url-input-wrapper';

/** Suffix for UrlInputField. Houses all icons w/ actions for the input field. */
export const UrlInputFieldIcons = ({
  mediumDataKey,
  url,
}: { mediumDataKey: MediumDataKey; url?: string }) => {
  const { liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const data = (liveTemplate?.mediumData || {}) as MediumContent;
  const hasMovableInkTile = useHasMovableInkTile();

  // inserting (or replacing) the asset url into a form field
  const onSelect = (url: string) => {
    const mediumDataKeyArray = mediumDataKey.split('.');
    if (mediumDataKeyArray.length > 1) {
      // handle nested mediumDataKeys
      const parentKey = mediumDataKeyArray.shift() as MediumDataKey;
      // @ts-ignore TS7053
      const parentValue = { ...data[parentKey] };
      set(parentValue, mediumDataKeyArray.join('.'), url);
      setCurrentMediumField(parentKey, parentValue);
    } else {
      setCurrentMediumField(mediumDataKey, url);
    }
  };
  return (
    <IconSuffixWrapper data-test={DATA_TEST_ID}>
      <CreativeLibraryIconButton onSelect={onSelect} url={url} />
      {hasMovableInkTile && <MovableInkIconButton onSelect={onSelect} />}
    </IconSuffixWrapper>
  );
};
